import { createTheme } from '@mui/material/styles';
import { csCZ } from '@mui/material/locale';
import createBreakpoints from '@mui/system/createTheme/createBreakpoints';

const font = 'TT Hoves,sans-serif';

const breakpoints = createBreakpoints({});

export const colors = {
    primary_V2: '#FBFBFB',
    primary_V1: '#EC0B4A',
    primary_O: '#E72D61',
    primary_O1: '#ed7d9e',
    primary_1: '#FDEFF3',
    primary_D1: '#EC5581',
    primary_D2: '#FFE8EE',
    primary_D3: '#FFF8F8',
    primary_W: '#FFFFFF',

    accent_V2: '#07555A',
    accent_V1: '#52D05F',
    accent_O: '#54C65F',
    accent_D1: '#93E191',
    accent_D2: '#A7ECA5',
    accent_D3: '#F1FFF6',

    alert_V2: '#980C0C',
    alert_V1: '#CF1B1B',
    alert_O: '#EE3B3B',
    alert_D1: '#F9675D',
    alert_D2: '#FD8B84',
    alert_D3: '#FFF8F8',
    alert_OR: '#ED9937',

    warning_O: '#FF9800',
    warning_D1: '#FF9800',
    warning_D2: '#FFC979',

    text_T0: '#001726',
    text_T1: '#1E2F55',
    tableLink: '#1D2F5C',
    text_T2: '#7E8CB2',
    text_T25: '#98A5C4',
    text_T3: '#B2BED6',

    'background_B-1': '#F8F9FE',
    background_B0: '#F6F9FF',
    background_B1: '#ECF0F8',
    background_B2: '#E7EBF4',
    background_B3: '#D5DCEC',
    background_BQ: '#ECF1FB',
    background_W: '#FFFFFF',
    background_LB: '#FBFCFF',

    avatar_border: '#B2BED9',

    icon: '#616d88',

    appMessageInfo: '#03a9f4',

};

export const sizes = {
    display_W: '400',
    display_FS: '60px',
    display_LH: '72px',

    heading_1_W: '400',
    heading_1_FS: '30px',
    heading_1_LH: '42px',

    heading_2_W: '400',
    heading_2_FS: '20px',
    heading_2_LH: '23.56px',

    heading_3_W: '400',
    heading_3_FS: '18px',
    heading_3_LH: '21.2px',

    heading_4_W: '600',
    heading_4_FS: '14px',
    heading_4_LH: '26px',
    heading_4_LS: '1px',

    body_W: '400',
    body_FS: '16px',
    body_LH: '18.85px',

    small_W: '400',
    small_FS: '14px',
    small_LH: '18px',

    micro_W: '400',
    micro_FS: '12px',
    micro_LH: '16px',

    bold_W: '600',

    button_S_PD: '8px 16px',

    button_M_PD: '12px 20px',

    button_L_PD: '16px 24px',

    // input_PD: '12.5px 16px',
    input_PD: '12.5px 16px 12.5px 16px',
    input_clear_icon_PD: '12.5px 0px 12.5px 16px',
    input_top_PD: '20px',
    input_bottom_PD: '5px',
    // input_label_left: "-13px",
    input_label_ML: '2px',
    input_end_icon_PD: '0px 14px 0px 0px',

    switch_MG: '23.5px 0px 25.5px 16px',

    border: '1.5px',
    radius: '2px',

    icon_button_FS: '24px',

    tab_item_PD: '13px 16px',

    body_top: '85px',
    body_bottom: '55px',
    body_left: '255px',
    body_right: '15px',
    // body_mobile_top: '85px',
    body_mobile_top: '75px',
    // body_mobile_bottom: '15px',
    body_mobile_bottom: '55px',
    // body_mobile_left: '15px',
    body_mobile_left: '5px',
    // body_mobile_right: '15px',
    body_mobile_right: '5px',
    body_mobile_PD: '0px',
    // body_PD: '15px 36px',
    body_PD: '15px',
    body_PD_N: 15,
    body_top_PD: '0px 0px 15px 0px',

    file_input_MB: '10px',
    // file_input_W: '337px',
    file_input_W: '220px',
    file_input_svg_R: '20px',
    file_input_svg_height: '26px',

    table_input_PD: '6px',
    table_input_autocomplete_PD: '6px 0px',

    table_3_rows_MH: 225,

    table_action_with_input_H: '57px',
    table_select_col_W: '40px',
    table_action_col_W: '45px',

    blocks_top_MG: '20px',

    top_menu_actions_size: '20px',
    top_menu_actions_PD: '0px 10px',
    top_menu_actions_H: '40px',
    top_menu_actions_svg_MR: '10px',

    icon_button_next_to_input_MG: '20px 0px 0px 2px',
    icon_button_next_to_input_svg_size: '34px',
};

export const tableFontSize = '13px';

const theme = createTheme(
    {
        palette: {
            primary: { main: colors.primary_O },
        },
        typography: {
            fontFamily: font,
            h1: {
                fontWeight: sizes.heading_1_W,
                fontSize: sizes.heading_1_FS,
                lineHeight: sizes.heading_1_LH,
                color: colors.text_T0,
            },
            h2: {
                fontWeight: sizes.heading_2_W,
                fontSize: sizes.heading_2_FS,
                lineHeight: sizes.heading_2_LH,
                color: colors.text_T0,
            },
            h3: {
                fontWeight: sizes.heading_3_W,
                fontSize: sizes.heading_3_FS,
                lineHeight: sizes.heading_3_LH,
                color: colors.text_T0,
            },
            h4: {
                fontWeight: sizes.heading_4_W,
                fontSize: sizes.heading_4_FS,
                lineHeight: sizes.heading_4_LH,
                color: colors.text_T1,
                textTransform: 'uppercase',
            },
            body1: {
                fontWeight: sizes.body_W,
                fontSize: sizes.body_FS,
                lineHeight: sizes.body_LH,
                color: colors.text_T1,
            },
            body2: {
                fontWeight: sizes.small_W,
                fontSize: sizes.small_FS,
                lineHeight: sizes.small_LH,
                color: colors.text_T1,
            },
            caption: {
                fontWeight: sizes.micro_W,
                fontSize: sizes.micro_FS,
                lineHeight: sizes.micro_LH,
                color: colors.text_T1,
            },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontWeight: sizes.body_W,
                        fontSize: sizes.body_FS,
                        lineHeight: sizes.body_LH,
                        borderRadius: sizes.radius,
                        boxShadow: 'none',
                        textTransform: 'unset',

                        '&.order-select-provider-button': {
                            [breakpoints.up('sm')]: {
                                float: 'right',
                            },
                            [breakpoints.down('sm')]: {
                                marginTop: sizes.body_PD,
                            },
                        },
                    },
                    fullWidth: {
                        display: 'block',
                    },
                    containedPrimary: {
                        backgroundColor: colors.primary_O,
                        color: colors.primary_W,

                        ':active': {
                            backgroundColor: colors.primary_V1,
                            boxShadow: 'none',
                            ':hover': {
                                backgroundColor: colors.primary_V1,
                            },
                        },
                        ':hover': {
                            backgroundColor: colors.primary_D1,
                            boxShadow: 'none',
                        },
                        ':disabled': {
                            color: colors.primary_W,
                            backgroundColor: colors.primary_O,
                            opacity: '0.5',
                            boxShadow: 'none',
                        },
                        'Mui-focusVisible': {
                            backgroundColor: colors.primary_V1,
                        },

                        '& svg': {
                            width: '16px',
                            height: '16px',

                            ' path': {
                                fill: colors.primary_W,
                                stroke: colors.primary_W,
                            },
                        },
                    },
                    outlinedPrimary: {
                        backgroundColor: colors.primary_W,
                        color: colors.primary_O,
                        borderColor: colors.primary_O,
                    },
                    sizeSmall: {
                        padding: sizes.button_S_PD,
                    },
                    sizeMedium: {
                        padding: sizes.button_M_PD,
                    },
                    sizeLarge: {
                        padding: sizes.button_L_PD,
                    },
                },
            },

            MuiTextField: {
                styleOverrides: {
                    root: {
                        paddingTop: sizes.input_top_PD,
                        paddingBottom: sizes.input_bottom_PD,
                        // marginTop: "15px",
                        // marginBottom: "15px",

                        label: {
                            root: {
                                fontSize: '30px',
                            },
                        },

                        '& .MuiOutlinedInput-root': {
                            padding: 0,
                        },

                        '& input:-internal-autofill-selected': {
                            backgroundColor: colors.primary_W + ' !important',
                            fontSize: '30px',
                            transition: 'background-color 5000s ease-in-out 0s, font-size 5000s ease-in-out 0s',
                        },

                        '& .MuiInputBase-adornedEnd': {
                            paddingRight: '0px',
                            backgroundColor: colors.primary_W,
                        },

                        '& .MuiInputAdornment-positionEnd': {
                            ' button': {
                                padding: sizes.input_end_icon_PD,

                                ' :hover': {
                                    color: colors.text_T1,
                                    backgroundColor: colors.primary_W,
                                },
                            },
                        },

                        '& label': {
                            fontSize: sizes.small_FS,
                            lineHeight: sizes.small_LH,
                            fontWeight: sizes.small_W,
                            color: colors.text_T2,
                            // left: sizes.input_label_left,
                            transform: 'unset',
                            transition: 'unset',
                            backgroundColor: 'transparent',

                            '&.Mui-disabled': {
                                color: colors.text_T2,
                            },
                            '&.Mui-focused': {
                                color: colors.text_T2,
                            },
                            '&.Mui-error': {
                                color: colors.text_T2,
                                backgroundColor: 'transparent',
                            },

                            '& .MuiInputLabel-asterisk': {
                                color: colors.primary_O,
                            },
                        },

                        '& .MuiFormHelperText-root': {
                            fontSize: sizes.micro_FS,
                            lineHeight: sizes.micro_LH,
                            fontWeight: sizes.micro_W,
                            color: colors.text_T2,
                            marginLeft: sizes.input_label_ML,
                            backgroundColor: 'transparent',

                            '&.Mui-error': {
                                color: colors.primary_O,
                                backgroundColor: 'transparent',
                            },
                        },

                        '& .MuiInputBase-root': {
                            ' .MuiInputBase-input': {
                                height: sizes.body_LH,
                                fontSize: sizes.body_FS,
                                lineHeight: sizes.body_LH,
                                color: colors.text_T1,
                                backgroundColor: colors.background_W,
                                padding: sizes.input_PD,

                                '&.has-clear-icon': {
                                    padding: sizes.input_clear_icon_PD,
                                },
                            },
                            ' .MuiOutlinedInput-notchedOutline': {
                                borderRadius: sizes.radius,
                                borderColor: colors.text_T3,
                                borderWidth: sizes.border,
                                top: '0px',

                                ' legend': {
                                    display: 'none',
                                },
                            },

                            '&.Mui-focused': {
                                '.MuiOutlinedInput-notchedOutline': {
                                    borderWidth: sizes.border,
                                    borderColor: colors.text_T1,
                                },
                            },

                            '&.Mui-disabled': {
                                ' .MuiInputBase-input': {
                                    opacity: 0.6,
                                    WebkitTextFillColor: 'unset',
                                },
                                '.MuiOutlinedInput-notchedOutline': {
                                    borderWidth: sizes.border,
                                    borderColor: colors.text_T3,
                                    opacity: 0.6,
                                },

                                '.MuiSelect-icon': {
                                    display: 'none',
                                },

                                '& [data-testid="CalendarIcon"]': {
                                    display: 'none',
                                },
                            },

                            '&.Mui-error': {
                                ' .MuiInputBase-input': {
                                    backgroundColor: colors.alert_D3,
                                },
                                ' .MuiOutlinedInput-notchedOutline': {
                                    borderColor: colors.alert_O,
                                },
                            },
                        },

                        '& .Mui-error': {
                            backgroundColor: colors.alert_D3,
                            '& .MuiInputAdornment-positionEnd': {
                                backgroundColor: colors.alert_D3,

                                '& svg': {
                                    ' path': {
                                        fill: colors.alert_O,
                                    },
                                },

                                '& button:hover': {
                                    backgroundColor: colors.alert_D3,
                                },
                            },
                        },

                        '& .Mui-disabled': {
                            '& .MuiInputAdornment-positionEnd': {
                                '& svg': {
                                    opacity: 0.6,
                                    ' path': {
                                        fill: colors.text_T1,
                                    },
                                },
                            },
                        },

                        '&.has-clear-icon': {
                            '& .MuiSvgIcon-root.MuiSelect-icon': {
                                position: 'relative',
                                right: 'unset',
                            },

                            '& input[type="number"]': {
                                padding: sizes.input_clear_icon_PD,
                            },

                            '& .number-filter-clear': {},
                        },
                    },
                },
            },

            MuiSelect: {
                styleOverrides: {
                    select: {
                        minHeight: sizes.body_LH,
                    },
                },
            },

            MuiFormControlLabel: {
                styleOverrides: {
                    root: {
                        '&.input-switch': {
                            // margin: sizes.switch_MG,
                            marginLeft: '0px',

                            '&.Mui-disabled > svg': {
                                opacity: 0.6,
                            },

                            '& .MuiFormControlLabel-label.Mui-disabled': {
                                color: colors.text_T1,
                            },
                        },
                    },
                },
            },

            MuiAutocomplete: {
                styleOverrides: {
                    root: {
                        '& .MuiOutlinedInput-root': {
                            padding: 0,

                            '& .MuiInputBase-input': {
                                padding: sizes.input_PD,

                                '&.has-clear-icon': {
                                    padding: sizes.input_clear_icon_PD,
                                },
                            },
                        },
                    },
                    hasClearIcon: {
                        '&.MuiAutocomplete-hasPopupIcon .MuiFormControl-root .MuiOutlinedInput-root': {
                            paddingRight: 0,
                            padding: 0,

                            '& .MuiInputBase-input': {
                                padding: sizes.input_PD,
                                paddingRight: '45px',
                            },
                        },
                    },
                },
            },

            MuiCircularProgress: {
                styleOverrides: {
                    root: {
                        color: colors.primary_O,
                    },
                },
            },

            MuiToolbar: {
                styleOverrides: {
                    root: {
                        minHeight: '70px',
                        // '@media (min-width: 600px)': {
                        //     minHeight: '70px',
                        // },
                        [breakpoints.up('sm')]: {
                            minHeight: '70px',
                        },
                    },
                },
            },

            MuiAppBar: {
                styleOverrides: {
                    root: {
                        backgroundColor: colors.background_W,
                        color: colors.text_T0,
                        boxShadow: 'unset',
                    },
                },
            },

            MuiDrawer: {
                styleOverrides: {
                    paper: {
                        borderRight: 'unset',

                        '& .MuiDivider-root': {
                            marginTop: '4px',
                            marginBottom: '12px',
                        },

                        '& .MuiButtonBase-root': {
                            padding: 0,
                            paddingLeft: '10px',
                            margin: '0px 11px',
                            marginBottom: '8px',
                            height: '44px',
                        },

                        '& .active .without-active-icon': {
                            '& svg': {
                                color: colors.primary_O,
                                fill: colors.primary_O,

                                '& path': {
                                    fill: colors.primary_O,
                                },
                            },
                        },

                        '& .active .MuiButtonBase-root': {
                            backgroundColor: colors.background_B1,

                            '& .MuiTypography-root': {
                                fontWeight: '600',
                            },
                        },

                        '& .MuiListItemIcon-root': {
                            minWidth: '28px',
                        },
                    },
                },
            },

            MuiTable: {
                styleOverrides: {
                    root: {
                        '& .MuiFormHelperText-root': {
                            display: 'none',
                        },

                        '& .MuiTableHead-root': {
                            '& .MuiTableCell-head': {
                                '& .MuiAutocomplete-root': {
                                    '& .MuiOutlinedInput-root': {
                                        '& .MuiInputBase-input': {
                                            padding: '6px 16px',
                                            paddingRight: '40px',
                                        },
                                    },
                                    '& .MuiAutocomplete-tag': {
                                        height: sizes.icon_button_FS,
                                    },
                                },

                                '& .MuiAutocomplete-inputRoot': {
                                    flexWrap: 'nowrap',
                                    // flexWrap: 'nowrap !important',

                                    '& .MuiInputBase-input': {
                                        padding: sizes.table_input_autocomplete_PD,
                                        minWidth: 0,
                                    },

                                    '& > span': {
                                        padding: 0,
                                    },
                                },
                            },
                        },

                        '& .MuiTableRow-root': {
                            '& label': {
                                top: '-6px',
                                background: 'white',
                                left: '10px',
                                height: '12px',
                                width: '12px',
                            },

                            '& .MuiTextField-root': {
                                paddingTop: '0px',
                                paddingBottom: '0px',
                            },

                            '& .MuiInputBase-input': {
                                padding: sizes.table_input_PD,
                                minWidth: 0,
                                '&.has-clear-icon': {
                                    padding: sizes.input_clear_icon_PD,
                                },
                            },
                            '& .MuiOutlinedInput-root .MuiInputBase-input': {
                                padding: sizes.table_input_PD,
                                minWidth: 0,
                                '&.has-clear-icon': {
                                    padding: sizes.input_clear_icon_PD,
                                },
                            },
                            '& .MuiAutocomplete-inputRoot': {
                                padding: 0,
                                minWidth: 0,
                            },
                        },
                    },
                },
            },

            MuiPopover: {
                styleOverrides: {
                    root: {
                        '& .table-filter-menu-item': {
                            borderBottom: '1px solid silver',
                            width: '100%',
                            textAlign: 'center',
                            padding: 0,

                            '& > div': {
                                padding: '6px 16px',
                            },
                        },
                        '&.body-top-block-menu': {
                            '& .MuiList-root': {
                                paddingTop: 0,
                                paddingBottom: 0,

                                '& .body-top-block-menu-item': {
                                    minHeight: 'unset',
                                    '& button': {
                                        verticalAlign: 'middle',
                                        padding: sizes.top_menu_actions_PD,
                                        height: sizes.top_menu_actions_H,

                                        '&.active': {
                                            borderColor: colors.primary_O,
                                            color: colors.primary_O,
                                        },

                                        '& svg': {
                                            float: 'left',
                                            verticalAlign: 'middle',
                                            width: sizes.top_menu_actions_size,
                                            height: sizes.top_menu_actions_size,
                                            marginRight: sizes.top_menu_actions_svg_MR,
                                        },
                                    },
                                    borderBottom: '1px solid silver',
                                    width: '100%',
                                    textAlign: 'center',
                                    padding: 0,

                                    '& > div': {
                                        padding: '6px 16px',
                                    },

                                    '& .MuiDivider-fullWidth': {
                                        borderColor: 'red',
                                        border: '1px solid silver',
                                        width: '100%',
                                    },
                                },
                            },
                        },
                    },
                },
            },

            MuiPaper: {
                styleOverrides: {
                    root: {
                        '&.MuiPickersPopper-paper': {
                            '& .MuiPickersRange-selected': {
                                backgroundColor: colors.primary_O,
                                fontWeight: 500,
                                color: '#fff',
                                borderRadius: 'unset',

                                '&.MuiPickersRange-selected-start': {
                                    borderRadius: '50% 0 0 50%',
                                },
                                '&.MuiPickersRange-selected-end': {
                                    borderRadius: '0 50% 50% 0',
                                },
                                '&.MuiPickersRange-selected-start.MuiPickersRange-selected-end': {
                                    borderRadius: '50%',
                                },
                            },
                        },
                    },
                },
            },

            MuiGrid: {
                styleOverrides: {
                    root: {
                        paddingTop: '0px',
                        '&>.MuiGrid-item': {
                            paddingTop: '0px',
                        },
                    },
                    container: {
                        paddingTop: '16px',
                    },
                    item: {
                        paddingTop: '0px',
                    },
                },
            },

            MuiSwitch: {
                styleOverrides: {
                    root: {
                        '& .MuiSwitch-thumb': {
                            border: `1px solid ${colors.text_T25}`,
                            boxShadow: 'none',
                        },
                        '&  .MuiSwitch-track': {
                            opacity: 1,
                            backgroundColor: colors.text_T25,
                            display: 'inline-flex',
                            position: 'absolute',
                            top: '9px',
                            bottom: '9px',
                            left: '9px',
                            right: '9px',
                            borderRadius: '10px',
                            width: 'unset',
                            height: 'unset',
                        },

                        '& .Mui-checked': {
                            '& .MuiSwitch-thumb': {
                                border: `1px solid ${colors.primary_O}`,
                                backgroundColor: colors.primary_W,
                            },
                        },
                        '&  span.Mui-checked+.MuiSwitch-track': {
                            backgroundColor: colors.primary_O,
                            opacity: 1,
                        },
                        '&.MuiButtonBase-root .Mui-checked+.MuiSwitch-track': {
                            opacity: 1,
                        },

                        '& .Mui-disabled .MuiSwitch-thumb': {
                            border: `1px solid ${colors.text_T3}`,
                            backgroundColor: colors.primary_W,
                        },
                        '&.MuiSwitch-sizeMedium  .Mui-disabled+.MuiSwitch-track': {
                            opacity: 1,
                            backgroundColor: colors.text_T3,
                        },
                        '&.MuiSwitch-sizeMedium .Mui-checked.Mui-disabled+.MuiSwitch-track': {
                            backgroundColor: colors.primary_D1,
                        },
                        '& .Mui-disabled.Mui-checked .MuiSwitch-thumb': {
                            border: `1px solid ${colors.primary_D1}`,
                        },
                    },
                },
            },
            MuiButtonBase: {
                styleOverrides: {
                    root: {
                        '&.Mui-checked': {
                            svg: {
                                fill: colors.primary_O,
                            },
                        },
                    },
                },
            },

            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        fill: colors.icon,
                    },
                },
            },
        },
    },
    csCZ
);

export default theme;
